import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/app/about/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/port/components/common/Header.tsx");
